module.exports = __webpack_public_path__ + "img/align-horizontal-center.bd78b411.svg";